import { render, staticRenderFns } from "./traMediciHouseCount.vue?vue&type=template&id=bf86735a&scoped=true"
import script from "./traMediciHouseCount.vue?vue&type=script&lang=js"
export * from "./traMediciHouseCount.vue?vue&type=script&lang=js"
import style0 from "./traMediciHouseCount.vue?vue&type=style&index=0&id=bf86735a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf86735a",
  null
  
)

export default component.exports